import axios from "axios";
import * as actionType from "../../../constant/actionType";
export const GetProviderPaymentTypeInfo = (apiData) => async (dispatch) => {
  /*** API Call Action ***/
  try {
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/provider/GetProviderPaymentTypeInfo`,
      params: apiData,
    });
    return response.data;
  } catch (error) {
    return {
      success: false,
      status: error.response?.status || 500, // Get status code or default to 500
      message: error.response?.data || { msg: error.message }, // Handle different response structures
    };
  }
};
